import React, { useState } from 'react'
import { Box, Button, CircularProgress, Stack, TextField, Typography, Card, CardContent, useMediaQuery, useTheme } from '@mui/material'
import { Navbar } from '../features/navigation/components/Navbar'
import { Footer } from '../features/footer/Footer'
import { axiosi } from '../config/axios'
import CloudUploadIcon from '@mui/icons-material/CloudUpload'

export const AddTesterPage = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const [loading, setLoading] = useState(false)
  const [message, setMessage] = useState('')
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    price: '',
    image: '',
    volume: '5ml',
    brand: '',
    inStock: true
  })

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData(prev => ({
      ...prev,
      [name]: name === 'price' ? parseFloat(value) : value
    }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    try {
      setLoading(true)
      await axiosi.post('/testers', formData)
      setMessage('Tester added successfully!')
      setFormData({
        name: '',
        description: '',
        price: '',
        image: '',
        volume: '5ml',
        brand: '',
        inStock: true
      })
      setTimeout(() => setMessage(''), 3000)
    } catch (error) {
      setMessage('Error adding tester: ' + error.message)
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <Navbar />
      
      <Box sx={{ minHeight: '80vh', py: 6, px: isMobile ? 2 : 4 }}>
        <Stack spacing={4} maxWidth={800} mx="auto">
          <Typography variant="h4" sx={{ fontWeight: 700, color: 'primary.main' }}>
            Add New Tester
          </Typography>

          <Card>
            <CardContent>
              <form onSubmit={handleSubmit}>
                <Stack spacing={3}>
                  <TextField
                    fullWidth
                    label="Tester Name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />

                  <TextField
                    fullWidth
                    label="Description"
                    name="description"
                    value={formData.description}
                    onChange={handleChange}
                    multiline
                    rows={4}
                    required
                  />

                  <TextField
                    fullWidth
                    label="Price (PKR)"
                    name="price"
                    type="number"
                    value={formData.price}
                    onChange={handleChange}
                    required
                  />

                  <Box>
                    <Typography variant="subtitle2" sx={{ mb: 1 }}>Image</Typography>
                    <Button
                      variant="outlined"
                      component="label"
                      fullWidth
                      startIcon={<CloudUploadIcon />}
                    >
                      {formData.image ? 'Change Image' : 'Upload Image'}
                      <input
                        hidden
                        accept="image/*"
                        type="file"
                        onChange={async (e) => {
                          const file = e.target.files?.[0]
                          if (!file) return
                          const reader = new FileReader()
                          reader.onload = () => {
                            setFormData(prev => ({ ...prev, image: reader.result }))
                          }
                          reader.readAsDataURL(file)
                        }}
                      />
                    </Button>

                    {formData.image && (
                      <Box sx={{ mt: 2, display: 'flex', justifyContent: 'center' }}>
                        <Box component="img" src={formData.image} alt="preview" sx={{ maxHeight: 160, borderRadius: 1 }} />
                      </Box>
                    )}
                  </Box>

                  <TextField
                    fullWidth
                    label="Volume (ml)"
                    name="volume"
                    value={formData.volume}
                    onChange={handleChange}
                  />

                  <TextField
                    fullWidth
                    label="Brand"
                    name="brand"
                    value={formData.brand}
                    onChange={handleChange}
                    required
                  />

                  {message && (
                    <Typography sx={{ color: message.includes('Error') ? 'error.main' : 'success.main' }}>
                      {message}
                    </Typography>
                  )}

                  <Button
                    fullWidth
                    variant="contained"
                    type="submit"
                    disabled={loading}
                    startIcon={loading ? <CircularProgress size={20} /> : <CloudUploadIcon />}
                  >
                    {loading ? 'Adding...' : 'Add Tester'}
                  </Button>
                </Stack>
              </form>
            </CardContent>
          </Card>
        </Stack>
      </Box>

      <Footer />
    </>
  )
}
